/* Endora PDP — vanilla JS bundle (no dependencies)
   Covers: ATF carousel (8 slides + tabs + arrows + swipe), tier selector,
   FAQ accordion, sticky CTA bar, "See more" comments, smooth-scroll CTAs.
   All hooks are data-attributes injected in the static DOM:
     [data-carousel] [data-carousel-slide] [data-carousel-tabs] [data-carousel-tab]
     [data-carousel-prev] [data-carousel-next] [data-tier] [data-sticky-cta] [data-see-more]
   KACHING: see comments in section 2.
   Liquid port (2026-07-30): section 2 now writes the selected variant id into the product
   form's hidden #id input and updates the mobile sticky-bar price. The actual Kaching
   bundle-discount recalculation call is marked with a TODO below — plug in Kaching's
   documented JS API or re-dispatch their expected `change` event at that exact spot. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- 1. ATF carousel ---------- */
  var root = $('[data-carousel]');
  if (root) {
    var slides = $$('[data-carousel-slide]', root);
    var tabs = $$('[data-carousel-tab]', root);
    var tabsRow = $('[data-carousel-tabs]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);
    var ACTIVE = ['bg-[#241D18]', 'text-[#F5EDE0]', 'shadow'];
    var IDLE = ['text-[#6B5D4F]'];
    var idx = 0;
    var go = function (i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.style.display = k === idx ? '' : 'none'; });
      tabs.forEach(function (t, k) {
        var on = k === idx;
        ACTIVE.forEach(function (c) { t.classList.toggle(c, on); });
        IDLE.forEach(function (c) { t.classList.toggle(c, !on); });
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      /* Scroll only the tabs strip itself (never the page) to bring the active tab into
         view. Plain scrollIntoView() can bubble the scroll up to ancestor containers/the
         page body on some mobile browsers, which was shifting the whole hero section
         sideways whenever a tab further along the strip (e.g. "Adeno?", "Gifting?") was
         selected. Computing scrollLeft on the tabs row directly avoids that entirely. */
      if (tabs[idx] && tabsRow) {
        var tEl = tabs[idx];
        var target = tEl.offsetLeft - (tabsRow.clientWidth - tEl.offsetWidth) / 2;
        target = Math.max(0, Math.min(target, tabsRow.scrollWidth - tabsRow.clientWidth));
        if (tabsRow.scrollTo) { tabsRow.scrollTo({ left: target, behavior: 'smooth' }); }
        else { tabsRow.scrollLeft = target; }
      }
    };
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) go(dx < 0 ? idx + 1 : idx - 1);
      x0 = null;
    }, { passive: true });
  }

  /* ---------- 2. Tier selector ----------
     KACHING INTEGRATION POINT:
     - Each [data-tier] button carries data-variant-id (set server-side in endora-atf.liquid
       to product.variants[0/1/2].id) and data-selling-plan if subscriptions are used.
     - On click: updates the hidden #id input of the product form (name="id") AND the mobile
       sticky-bar price, then notifies Kaching so bundle pricing/discount labels re-render. */
  var tiers = $$('[data-tier]');
  var hiddenIdInput = $('#endora-atf-product-form input[name="id"]');
  var stickyPriceEl = $('[data-sticky-price]');
  tiers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      tiers.forEach(function (b) {
        var wrap = b.closest('div');
        var radio = b.querySelector('span'); /* the round radio circle */
        if (wrap) { wrap.classList.remove('border-[#B88425]'); wrap.classList.add('border-[#E8DCC8]'); }
        if (radio) { radio.classList.remove('border-[#B88425]', 'bg-[#B88425]'); radio.classList.add('border-[#C9BBA2]'); radio.innerHTML = ''; }
      });
      var wrap = btn.closest('div');
      var radio = btn.querySelector('span');
      if (wrap) { wrap.classList.remove('border-[#E8DCC8]'); wrap.classList.add('border-[#B88425]'); }
      if (radio) {
        radio.classList.remove('border-[#C9BBA2]');
        radio.classList.add('border-[#B88425]', 'bg-[#B88425]');
        radio.innerHTML = '<span style="width:8px;height:8px;border-radius:9999px;background:#fff;display:block"></span>';
      }

      /* update the hidden product-form variant id so add-to-cart submits the right variant */
      var variantId = btn.getAttribute('data-variant-id');
      if (hiddenIdInput && variantId) {
        hiddenIdInput.value = variantId;
        hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* TODO (Kaching): call Kaching's bundle recalculation here, e.g.:
           if (window.Kaching && Kaching.recalculate) { Kaching.recalculate(variantId); }
         or re-dispatch whatever event their embed script listens for on the form —
         check Kaching's own integration docs for the exact call/event name. */

      /* keep the mobile sticky bar's price in sync with the selected tier, if present */
      if (stickyPriceEl && btn.dataset.tier) {
        var priceEl = btn.querySelector('.text-right .text-\\[19px\\]');
        var label = btn.querySelector('.text-\\[15px\\]');
        if (priceEl && label) {
          stickyPriceEl.textContent = label.textContent + ' — ' + priceEl.textContent;
        }
      }
    });
  });

  /* ---------- 3. FAQ accordion (radix/shadcn markup) ---------- */
  $$('h3 > button[aria-expanded]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-orientation]') || trigger.closest('div');
      var open = trigger.getAttribute('aria-expanded') === 'true';
      /* close all others (single-collapse behavior) */
      $$('h3 > button[aria-expanded="true"]').forEach(function (o) {
        if (o !== trigger) toggle(o, false);
      });
      toggle(trigger, !open);
    });
  });
  function toggle(trigger, open) {
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    trigger.setAttribute('data-state', open ? 'open' : 'closed');
    var id = trigger.getAttribute('aria-controls');
    var content = id ? document.getElementById(id) : null;
    if (!content) {
      var host = trigger.parentElement && trigger.parentElement.parentElement;
      content = host ? host.querySelector('[role="region"]') : null;
    }
    if (content) {
      content.setAttribute('data-state', open ? 'open' : 'closed');
      content.hidden = !open;
      content.style.display = open ? 'block' : 'none';
    }
  }
  /* initialize: ensure closed panels are hidden in the static snapshot */
  $$('h3 > button[aria-expanded="false"]').forEach(function (t) { toggle(t, false); });

  /* ---------- 4. Sticky CTA bar ----------
     The bar carries Tailwind's `translate-y-full` class, which (Tailwind v4) sets the native
     CSS `translate` property via a `!important` custom property, not `transform`. Setting
     .style.transform here did nothing, wrong property entirely. Use .style.setProperty on
     `translate` with 'important' priority so it reliably beats the class (inline !important
     beats class !important at equal origin, by specificity). */
  var sticky = $('[data-sticky-cta]');
  var buyBox = $('#buy');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      var e = en[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.style.setProperty('translate', show ? '0 0' : '0 110%', 'important');
    }, { threshold: 0 });
    io.observe(buyBox);
    sticky.style.transition = 'translate .3s cubic-bezier(0.23,1,0.32,1)';
  }

  /* ---------- 5. See more ---------- */
  $$('[data-see-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var p = btn.previousElementSibling;
      if (p) { p.style.webkitLineClamp = 'unset'; p.style.display = 'block'; p.classList.remove('line-clamp-3', 'line-clamp-4', 'line-clamp-5'); }
      btn.style.display = 'none';
    });
  });

  /* ---------- 6. Smooth scroll to buy box ----------
     CTAs scroll to #choose-protocol (the "Choose your protocol" heading right above the
     Kaching tier picker) rather than the top of the whole #buy section, so shoppers land
     exactly where they pick a bundle instead of at the product image. */
  $$('a[href="#buy"], a[href*="#buy"], a[href="#choose-protocol"], a[href*="#choose-protocol"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var targetId = a.getAttribute('href').replace('#', '');
      var t = document.getElementById(targetId) || $('#buy');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ---------- 6b. Marquee, driven by rAF instead of CSS @keyframes ----------
     Some browsers (Chromium on Windows with "Show animations" turned off in OS accessibility
     settings) silently stop CSS animations regardless of author !important overrides, because
     the suppression happens in the rendering engine, not the CSS cascade. Plain inline-style
     mutations via requestAnimationFrame are not affected by that, so drive the scroll by hand
     and disable the CSS animation to avoid the two fighting over the same transform. */
  var marquee = $('.animate-marquee');
  if (marquee) {
    marquee.style.animation = 'none';
    var mqWidth = marquee.scrollWidth / 2; // content is duplicated, so half = one full loop
    var mqSpeed = mqWidth / 55; // px per second, matching the original 55s/loop timing
    var mqPos = 0;
    var mqLast = null;
    var mqPaused = false;
    marquee.addEventListener('mouseenter', function () { mqPaused = true; });
    marquee.addEventListener('mouseleave', function () { mqPaused = false; });
    var mqStep = function (ts) {
      if (mqLast === null) mqLast = ts;
      var dt = (ts - mqLast) / 1000;
      mqLast = ts;
      if (!mqPaused) {
        mqPos -= mqSpeed * dt;
        if (mqPos <= -mqWidth) mqPos += mqWidth;
        marquee.style.transform = 'translateX(' + mqPos + 'px)';
      }
      requestAnimationFrame(mqStep);
    };
    requestAnimationFrame(mqStep);
  }

  /* ---------- 7. Add-to-cart -> straight to checkout (skip the cart drawer) ----------
     The theme's own global JS (theme.js) intercepts every product-form submit, POSTs to
     /cart/add.js via jQuery.ajax and opens the CartDrawer — a plain <input name="return_to">
     on the form has no effect there since it's an AJAX call, not a native form submission.
     Instead of fighting that handler (risky: Kaching also relies on the same submit event
     to inject its own fields), just listen for the same jQuery global ajaxSuccess event the
     theme already fires and redirect once the add actually lands in the cart. */
  if (window.jQuery) {
    jQuery(document).on('ajaxSuccess', function (evt, xhr, settings) {
      if (settings && settings.url && settings.url.indexOf('/cart/add') !== -1) {
        window.location.href = '/checkout';
      }
    });
  }
})();
